import "fixed-header-table";

$(function() {
    $(".js-dataSourcesTable").fixedHeaderTable({
        footer: false,
        cloneHeadToFoot: true,
        fixedColumn: true,
        height: 600,
        themeClass: 'Table Table--default'
    });
});